import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus, HandCoins } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function Activation() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const finish = async (to) => {
    if (!user?.onboarding_completed) {
      await api.post("/auth/complete-onboarding").catch(() => {});
    }
    navigate(to, { replace: true });
  };

  return (
    <div className="debii-shell flex flex-col px-6 py-12">
      <div className="flex-1 flex flex-col justify-center max-w-sm w-full mx-auto text-center">
        <div className="mx-auto h-16 w-16 rounded-2xl bg-secondary flex items-center justify-center animate-pop">
          <HandCoins className="h-8 w-8 text-primary" />
        </div>
        <h1 className="mt-6 font-display text-3xl font-extrabold text-foreground">Who owes you right now?</h1>
        <p className="mt-3 text-sm text-muted-foreground">Add your first record. It only takes a few seconds.</p>
        <div className="mt-8 space-y-3">
          <Button data-testid="activation-add-first" onClick={() => finish("/add")} className="w-full h-12 rounded-xl text-base">
            <Plus className="h-5 w-5" /> Add My First Debt
          </Button>
          <Button data-testid="activation-skip" variant="ghost" onClick={() => finish("/")} className="w-full h-11 rounded-xl">
            Nobody owes me right now
          </Button>
        </div>
      </div>
    </div>
  );
}
